/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_ACES_SECRET_QUESTION_PASSWORD_RESET } from './actionTypes';

import { postAcesSecretQuestionPasswordResetUtil } from './utils';

/**
 * Contains the action creator functions that update the UAUserAccount slice of the store.
 *
 * @namespace UAUserAccountActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/ua/aces_secret_question_password_reset
   *
   * @param {NewUASecretQuestionPasswordReset} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof UAUserAccountActions
   */
  static postAcesSecretQuestionPasswordReset = (
    dispatch,
    newUASecretQuestionPasswordReset,
    callback
  ) => {
    ReduxUtils.generateAction(
      dispatch,
      postAcesSecretQuestionPasswordResetUtil.bind(null, newUASecretQuestionPasswordReset),
      POST_ACES_SECRET_QUESTION_PASSWORD_RESET,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postAcesSecretQuestionPasswordReset.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof UAUserAccountActions
   */
  static resetPostAcesSecretQuestionPasswordReset = (dispatch, data) => {
    const json = {
      type: POST_ACES_SECRET_QUESTION_PASSWORD_RESET.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postAcesSecretQuestionPasswordReset.
   *
   * @param {function} dispatch
   * @function
   * @memberof UAUserAccountActions
   */
  static resetPostAcesSecretQuestionPasswordResetError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, POST_ACES_SECRET_QUESTION_PASSWORD_RESET.failureAction);
  };
}
